import { cva } from "./index.ts";

/**
 * Round controls of the full-screen camera screens (damage photo, damage video, inspection).
 * Sizes are fixed rem values: the Carvia spacing scale has no size-20 and a larger size-10.
 */
export const cameraButton = cva({
  base: "inline-flex shrink-0 appearance-none items-center justify-center rounded-full border-0 p-0 leading-none disabled:opacity-40",
  variants: {
    variant: {
      side: "size-[3.25rem] bg-black/40 text-white ring-1 ring-inset ring-white/25",
      /** A side control that is switched on, e.g. the marking pen. */
      sideActive:
        "size-[3.25rem] bg-white text-black ring-1 ring-inset ring-white",
      shutter:
        "relative size-[5rem] overflow-hidden border-4 border-solid border-white bg-transparent",
      confirm: "size-[5rem] overflow-hidden bg-white text-black",
      /** Icon above a short caption, e.g. "skip". */
      caption:
        "w-[5rem] flex-col gap-1 rounded-lg bg-transparent p-1 text-[11px] font-medium leading-tight text-white/80",
    },
  },
  defaultVariants: {
    variant: "side",
  },
});

/** Control bar of the full-screen damage cameras: along the bottom in portrait, at the right in landscape. */
export const cameraRail = cva({
  base: "absolute bg-black/50",
  variants: {
    orientation: {
      portrait: "inset-x-0 bottom-0 px-8 pb-10 pt-5",
      landscape: "inset-y-0 right-0 px-5 py-8 pr-10",
    },
  },
});

/** Controls inside the rail; reversed in landscape when the device is turned the other way. */
export const cameraControls = cva({
  variants: {
    layout: {
      row: "grid grid-cols-3 items-center",
      column: "flex h-full flex-col items-center justify-between",
      columnReversed:
        "flex h-full flex-col-reverse items-center justify-between",
    },
  },
});

/** One shot in the inspection camera's progress bar. */
export const cameraProgressSegment = cva({
  base: "pointer-events-auto h-[3px] flex-1 appearance-none rounded-full border-0 p-0 transition-colors",
  variants: {
    state: {
      current: "bg-white",
      captured: "bg-hazel-300",
      skipped: "bg-hazel-700",
      open: "bg-white/20",
    },
  },
});
